import { useEffect, useState } from 'react';

import { fetchCurrentUserPhotoUrl } from '@/lib/graph-photo';
import { fetchGraphUserPhotoUrl } from '@/lib/graph-photos';

export function useUserPhoto(enabled: boolean): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void fetchCurrentUserPhotoUrl().then((resolved) => {
      if (!cancelled) setUrl(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return url;
}

/**
 * Resolve the Microsoft Graph profile photo for a specific user (by UPN or
 * Graph object id). Returns `null` while loading, when the user has no photo,
 * when delegated consent for `User.ReadBasic.All` is unavailable, or in dev
 * mode. Components should always pair this with an `AvatarFallback`.
 */
export function useUserPhotoById(userIdOrUpn: string | null | undefined): string | null {
  const key =
    userIdOrUpn === null || userIdOrUpn === undefined || userIdOrUpn.length === 0
      ? null
      : userIdOrUpn;
  const [resolved, setResolved] = useState<{ key: string; url: string | null } | null>(null);

  useEffect(() => {
    if (key === null) return;
    let cancelled = false;
    void fetchGraphUserPhotoUrl(key).then((url) => {
      if (!cancelled) setResolved({ key, url });
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  if (resolved === null || resolved.key !== key) return null;
  return resolved.url;
}
